// extracted by mini-css-extract-plugin
export var button = "_bw-7";
export var buttonRow = "_bw-6";
export var fadeIn = "_bw-1";
export var gradient = "_bw-0";
export var panel = "_bw-2";
export var panelIn = "_bw-3";
export var subtitle = "_bw-5";
export var title = "_bw-4";